import $ from "jquery";
import JEditable from "jqueryEditable";

class DefaultEditable {

    element(settings, original) {
        const input = $('<input type="hidden"/>');
        if ($(this).data('placeholder')) {
            input.attr('placeholder', $(this).data('placeholder'));
        }
        $(input).css('text-align', 'inherit');
        $(this).append(input);
        return input;
    }

    content(string, settings, original) {
        $(':input:first', this).val(string);
    }

    reset(settings, original) {
        original.reset(this);
    }

    buttons(settings, original) {
        const form = this;
        if (settings.submit) {
            /* if given html string use that */
            const submit = settings.submit.match(/>$/)
                ? $(settings.submit).click(e => $(e.currentTarget).attr("type") !== "submit" && form.submit())
                : $('<button class="bg-hover-emerald fg-hover-white" title="click to save content" type="submit" />')
                    .html(settings.submit);
            $(this).append(submit);
        }
        if (settings.cancel) {
            /* if given html string use that */
            const cancel = settings.cancel.match(/>$/)
                ? $(settings.cancel)
                : $('<button class="bg-hover-red fg-hover-white" title="cancel" type="reset" />')
                    .html(settings.cancel);
            $(this).append(cancel);

            $(cancel).click(function (event) {
                original.cancelsubmit(event);
                //original.reset();
                const reset = new JEditable.types[settings.type]().reset;
                reset.apply(form, [settings, original]);
                return false;
            });
        }
    }
}

export default DefaultEditable;